import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DocumentStatus, SalesDocumentFilters } from '@icc/b2b/shared';

@Component({
    selector: 'icc-sales-document-filters',
    templateUrl: './sales-document-filters.component.html',
    styleUrls: ['./sales-document-filters.component.scss'],
})
export class SalesDocumentFiltersComponent {
    nrOffer = '';
    nrOrder = '';
    documentCode = '';
    status: number = null;
    creationDateFrom: Date = null;
    creationDateTo: Date = null;
    validityDateFrom: Date = null;
    validityDateTo: Date = null;
    client = '';
    authorUserId: number | null = null;
    protected _filters: SalesDocumentFilters;

    @Input() isOrderList = false;
    @Input() isInquiryList = false;
    @Input() isServiceOrderList = false;
    @Input() workersList: Record<string, string> | null = null;
    @Input()
    get filters(): SalesDocumentFilters {
        return this._filters;
    }
    set filters(filters: SalesDocumentFilters) {
        this.setFilters(filters);
    }
    @Input()documentStatuses: DocumentStatus[];

    @Input() side: 'purchase' | 'sales' = 'sales';

    @Input() showDocumentStatuses: boolean;
    @Output() filtersEmitter = new EventEmitter<{
        filters: SalesDocumentFilters;
        reset: boolean;
    }>();

    setFilters(filters: SalesDocumentFilters) {
        if (filters) {
            this._filters = filters;
            this.nrOffer = filters.nrOffer;
            this.nrOrder = filters.nrOrder;
            this.documentCode = filters.documentCode;
            this.status = filters.status;
            this.creationDateFrom = filters.creationDateFrom;
            this.creationDateTo = filters.creationDateTo;
            this.validityDateFrom = filters.validityDateFrom;
            this.validityDateTo = filters.validityDateTo;
            this.client = filters.client;
            this.authorUserId = filters.authorUserId;
        } else {
            this.resetFilters(false);
        }
    }

    handleStatus(value) {
        this.status = !isNaN(+ value) ? + value : null;
    }

    handleWorkers(value) {
        this.authorUserId = !isNaN(+ value) ? + value : null;
    }

    emitFilters(reset = false) {
        this.filtersEmitter.emit({
            filters: {
                nrOffer: this.nrOffer,
                nrOrder: this.nrOrder,
                documentCode: this.documentCode,
                status: this.status,
                creationDateFrom: this.creationDateFrom,
                creationDateTo: this.creationDateTo,
                validityDateFrom: this.validityDateFrom,
                validityDateTo: this.validityDateTo,
                client: this.client,
                authorUserId: this.authorUserId,
            },
            reset,
        });
    }

    resetFilters(emit = true) {
        this.nrOffer = '';
        this.nrOrder = '';
        this.documentCode = '';
        this.status = null;
        this.creationDateFrom = null;
        this.creationDateTo = null;
        this.validityDateFrom = null;
        this.validityDateTo = null;
        this.client = '';
        this.authorUserId = null;
        if(emit)this.emitFilters(true);
    }

}
